import FloorMeasurementValues from './FloorMeasurementValues';

export default FloorMeasurementValues ;